import React from 'react';
import GenericFeatures from '../GenericFeatures';

const FEATURES = [
  {
    name: 'Online textbook',
    icon: 'fad fa-books',
    description:
      'Our comprehensive online textbook. Easy to read, mobile-friendly, and with detailed breakdowns of sample questions. Written by an industry-leading expert with 15+ years of experience.',
  },
  {
    name: 'Quantitative question bank',
    icon: 'fad fa-function',
    description:
      "Practice with an infinite amount of GRE quantitative questions. We randomize question text and variables with 150+ templates to be sure you're learning the concepts instead of simply recalling answers. Backed by Achievable's memory tracking to help you study effectively.",
  },
  {
    name: 'Verbal / reading comprehension',
    icon: 'fad fa-book-reader',
    description:
      "200+ high-quality hand-crafted verbal / reading comprehension questions. That's enough for 10 full-length exams.",
  },
  {
    name: 'Vocabulary',
    icon: 'fad fa-ball-pile',
    description:
      "1500+ vocabulary words, grouped into semantic clusters. Backed by Achievable's memory tracking to help you study effectively.",
  },
  {
    name: 'Essay grading',
    icon: 'fad fa-keyboard',
    description:
      'Instant grading of essays through the use of machine learning, very similar to the scoring mechanisms used by the ETS. Ten unique essay prompts.',
  },
  {
    name: 'A full year of access',
    icon: 'fad fa-calendar-check',
    description:
      "You'll have plenty of time to prepare. And if life gets in the way, just let us know. We're people too and we understand.",
  },
  {
    name: 'Amazing customer support',
    icon: 'fad fa-users',
    description:
      "You've probably already noticed that our site is filled with various ways to talk with us. We want to hear from you!",
  },
];

const GreFeatures = () => <GenericFeatures features={FEATURES} />;

export default GreFeatures;
